import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CrmAppComponent } from '@touch4it/ng-swp/core';

@Component({
  selector: 'app-root',
  imports: [CrmAppComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
